export default "__VITE_ASSET__DbFWaLFm__"